export enum FastOfferOrderStatusEnum {
  // ACCEPTED = 1, // ордер принят на обработку
  // WAIT_FOR_OFFER = 2, // ожидаем создания оффера юзером, показываем продавцу данные покупателя из buyer
  // OFFER_CREATED = 3, // создан оффер, ожидание подтверждения продавцом
  // OFFER_SENT = 4, // оффер отправлен продавцом, ожидание принятия от покупателя
  //
  // OFFER_SUCCESS = 10, // сделка успешна
  //
  // SEND_TIMEOUT = 20, // истекло время на передачу предмета
  // RECEIVE_TIMEOUT = 21, // истекло время на прием предмета
  // OFFER_CANCELED_BY_SELLER = 22, // оффер был отменен продавцом
  // OFFER_CANCELED_BY_BUYER = 23, // оффер был отклонен покупателем
  // BUYER_TRADE_LINK_CHANGED = 30, // у покупателя изменилась trade ссылка
  // ITEM_DISAPPEARED = 31, // у продавца пропал предмет из инвентаря
  // ORDER_CANCELED_BY_SELLER = 80, // сделка отменена продавцом
  // ORDER_CANCELED_BY_FASTOFFER = 81, // сделка отменена нами
  // WRONG_API_KEY = 200, // неверный API ключ продавца
  // SELLER_CAN_NOT_TRADE = 201, // продавец не может обмениваться
  // BUYER_CAN_NOT_TRADE = 202, // покупатель не может обмениваться


  'Ордер принят на обработку' = 1,
  'Ожидание создания оффера' = 2,
  'Создан оффер, ожидание подтверждения продавцом' = 3,
  'оффер отправлен продавцом, ожидание принятия от покупателя' = 4,
  'Оффер на холде' = 5,

  'Сделка успешна' = 10,

  'Истекло время на передачу предмета' = 20,
  'Истекло время на прием предмета' = 21,
  'Оффер был отменен продавцом' = 22,
  'Оффер был отклонен покупателем' = 23,
  'У покупателя изменилась trade ссылка' = 30,
  'У продавца пропал предмет из инвентаря' = 31,
  'Сделка отменена продавцом' = 80,
  'Сделка отменена нами' = 81,
  'Продавец вернул оффер' = 82,
  'Неверный API ключ продавца' = 200,
  'Продавец не может обмениваться' = 201,
  'Покупатель не может обмениваться' = 202,
}

